export default __webpack_public_path__ + "static/logo-cf59e54ef4e9c13aab84ca8dcbf7891d.png";